var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmsbump(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b46a40f9-0420-4a3c-8b6c-a6db657e3919",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 262 258",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b862872b-d245-4d9e-8db3-7073b9f7f839,.e225dec3-4fca-4fe5-8fba-82fb4494a7d1{fill:none;}.b73d8e23-3201-4f9f-a5c8-619c349a4440{clip-path:url(#e0a5c69a-7803-4615-8642-3eb06acd7b4b);}.a907a074-0694-413f-82bc-0e618b74dbc0{clip-path:url(#aa071d69-3225-4a44-be8c-8585097e6212);}.f83a4b18-585b-4132-9c94-c10f4513503f{fill:#0042e4;}.e225dec3-4fca-4fe5-8fba-82fb4494a7d1{stroke:#262626;stroke-miterlimit:10;}.bc5325bd-12d1-40bc-b70f-770c4a734c53{clip-path:url(#a2cc71c8-5c74-467f-973b-08813e33378f);}.bebf40c4-c0be-4bb7-a14b-40d0ec00a1f7{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "e0a5c69a-7803-4615-8642-3eb06acd7b4b"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b862872b-d245-4d9e-8db3-7073b9f7f839",
    width: 262,
    height: 258
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aa071d69-3225-4a44-be8c-8585097e6212"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b862872b-d245-4d9e-8db3-7073b9f7f839",
    x: 50,
    y: 48,
    width: 162,
    height: 162,
    rx: 4.5,
    transform: "translate(-42.37 190.19) rotate(-64)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a2cc71c8-5c74-467f-973b-08813e33378f"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b862872b-d245-4d9e-8db3-7073b9f7f839",
    d: "M180.56,117.13l3.28,4.85-58.26,39.26L118.17,145l7.28-4.91,3.28,4.86Zm-22.82-12.88,3.28,4.86-58.27,39.26L87.94,116l4.86-3.27,13.11,19.42Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b73d8e23-3201-4f9f-a5c8-619c349a4440"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a907a074-0694-413f-82bc-0e618b74dbc0"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "f83a4b18-585b-4132-9c94-c10f4513503f",
    points: "93.71 20.69 239.31 91.71 168.29 237.31 22.69 166.29 93.71 20.69"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e225dec3-4fca-4fe5-8fba-82fb4494a7d1",
    d: "M97.75,22.66,235.27,89.73a4.51,4.51,0,0,1,2.07,6L170.27,233.27a4.51,4.51,0,0,1-6,2.07L26.73,168.27a4.51,4.51,0,0,1-2.07-6L91.73,24.73A4.51,4.51,0,0,1,97.75,22.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e225dec3-4fca-4fe5-8fba-82fb4494a7d1",
    d: "M92.69,8,250,84.67a4.5,4.5,0,0,1,2.08,6L175.33,248a4.5,4.5,0,0,1-6,2.08L12,173.33a4.5,4.5,0,0,1-2.08-6L86.67,10A4.5,4.5,0,0,1,92.69,8Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "bc5325bd-12d1-40bc-b70f-770c4a734c53"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "bebf40c4-c0be-4bb7-a14b-40d0ec00a1f7",
    points: "105.97 79 185.81 117.94 157.18 176.65 77.33 137.71 105.97 79"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsbump);
export default __webpack_public_path__ + "static/media/smsbump.b2860383831a4d295c79eb9ce880c2bd.svg";
export { ForwardRef as ReactComponent };